import groupQuiz from "./group-quiz.json";
import aiPlanetQuiz from "./ai-planet.json";
import mtfQuiz from "./mtf.json";

import gradingModels from "./grading-models.json"

export const assessments = [
    {
        assessmentId: "b92d3bce-49b3-4f59-b37e-08e95780f15b",
        status: "Active",
        courseCode: "CSE101",
        courseId: "1b6e2a1f-4e48-4b79-b9a6-d4b67b8f4ec4",
        sectionId: "3c6e0b8a-9f8e-4e12-8dd4-2edff720a1c3",
        chapterId: "f63c1a8f-8c72-4e3f-9123-3b1b8e3e1c4a",
        type: "Unit",
        timeAllowed: "40",
        noOfQuestions: "40",
        totalMarks: "80",
        gradingModel: "7f6c2a8d-5a4b-4b79-b4b9-2b9d4b8a9c2e",
        passGrade: "C",
        isTimed: "1",
        questions: groupQuiz.questions,
        createdDate: "2024-03-17T11:37:00Z",
        createdBy: "123e4567-e89b-12d3-a456-426614174000",
        createdUserName: "Lalitha",
        updateHistory: [
            {
                updatedBy: "987f6543-e21b-12d3-a456-426614174001",
                updatedDate: "2024-03-17T11:37:00Z",
                updatedUserName: "Veni",
                updateNotes: "Status changed",
            },
        ],
    },
    {
        assessmentId: "b92d3bce-49b3-4f59-b37e-38e95780f15b",
        status: "Active",
        courseCode: "AIPL7632",
        courseId: "1b6e2a1f-4e48-4b79-b9a6-d4b67b8f4ec4",
        sectionId: "3c6e0b8a-9f8e-4e12-8dd4-2edff720a1c3",
        chapterId: "f63c1a8f-8c72-4e3f-9123-3b1b8e3e1c4a",
        type: "Unit",
        timeAllowed: "40",
        noOfQuestions: "4",
        totalMarks: "40",
        gradingModel: "7f6c2a8d-5a4b-4b79-b4b9-2b9d4b8a9c2e",
        passGrade: "C",
        isTimed: "0",
        questions: mtfQuiz.questions,
        createdDate: "2024-03-17T11:37:00Z",
        createdBy: "123e4567-e89b-12d3-a456-426614174000",
        createdUserName: "Lalitha",
        updateHistory: [
            {
                updatedBy: "987f6543-e21b-12d3-a456-426614174001",
                updatedDate: "2024-03-17T11:37:00Z",
                updatedUserName: "Veni",
                updateNotes: "Status changed",
            },
        ],
    },
];

export const getById = id => {
    let assessment = assessments.find(a => a.assessmentId === id);

    assessment.gradingModel = gradingModels.find(
        g => g.gradingModelId === assessment.gradingModel
    );

    return assessment;
}

export const getGradingModel = id => {
    return gradingModels.find(g => g.gradingModelId === id);
}